import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as UserType from '@/helper/UserType'
import * as BasketTypes from '@/helper/BasketTypes'
import {
  DeleteBasket,
  ConfigProvider
} from '@/components'

export default {
  components: {
    DeleteBasket,
    ConfigProvider
  },
  data () {
    return {
      basketTypes: BasketTypes,
      userType: UserType,
      isLoadingAllbaskets: false,
      managerConfigProvider: false,
      managerDeleteBasket: false,
      search: '',
      selectedFilter: 'name',
      clientPlan: null,
      headers: [
        { text: 'Ações', align: 'center', sortable: false },
        { text: 'Nome', value: 'name', align: 'left' },
        { text: 'Habilitada', value: 'enable', align: 'center' },
        { text: 'Tipo', value: 'type', align: 'left' },
        { text: 'Preço', value: 'price', align: 'right' },
        { text: 'Qtde. Providers', value: 'baskets', align: 'right' },
        { text: 'Identificador', value: 'idProviderFlow', align: 'left' }
      ],
      listActions: [
        {
          name: 'Editar',
          value: 'edit',
          action: (item) => this.managerBasketsModals('edit', item)
        },
        {
          name: 'Remover',
          value: 'remove',
          action: (item) => this.managerBasketsModals('remove', item)
        }
      ],
      filterStatus: null,
      statuses: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
        { text: 'Todos', value: null }
      ],
      filterBasketType: null,
      basketTypesFilter: [
        { text: 'Busca', value: BasketTypes.BUSCA },
        { text: 'Validação', value: BasketTypes.VALIDACAO },
        { text: 'Hierárquica', value: BasketTypes.HIERARQUICA },
        { text: 'Kyc', value: BasketTypes.KYC },
        { text: 'Todos', value: null }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterBaskets'
    ]),
    availableBaskets () {
      return this.getterBaskets ? this.getterBaskets.filter(basket => basket.idClient === this.getterAccount.idClient) : []
    },
    filteredUsers () {
      let result = ''

      if (this.search !== '') {
        result = this.availableBaskets.filter((item) => {
          if (item[this.selectedFilter] !== null) {
            return item[this.selectedFilter].toLowerCase().includes(this.search.toLowerCase())
          }

          return item[this.selectedFilter]
        })
      } else {
        result = this.availableBaskets
      }

      if (this.filterStatus !== null) {
        result = result.filter((item) => item.enable === this.filterStatus)
      }

      if (this.filterBasketType !== null) {
        result = result.filter((item) => item.type === this.filterBasketType)
      }

      return result
    },
    filteredHeader () {
      return this.headers.filter((item) => item.value === 'name' || item.value === 'idProviderFlow')
    }
  },
  async mounted () {
    this.clientPlan = await this.getClientPlan()
    this.getAllBaskets()
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_BASKET'
    ]),
    ...mapActions([
      'actionGetAllBaskets',
      'actionGetAllClients',
      'actionGetPlanTypes'
    ]),

    formatPrice (item) {
      let sum = 0
      if (this.clientPlan) {
        if (this.clientPlan.name === 'Custom') {
          if (item.price && item.price > 0) {
            sum += item.price
          } else if (item.baskets && item.baskets.length > 0) {
            item.baskets.forEach(basket => {
              sum += basket.basketPrice
            })
          }
        } else if (item.baskets && item.baskets.length > 0) {
          item.baskets.forEach(basket => {
            if (basket.systemProvider.systemProviderSalesValues && basket.systemProvider.systemProviderSalesValues.length > 0 && basket.systemProvider.systemProviderSalesValues.some(value => value.idPlanType === this.clientPlan.idPlanType)) {
              if (item.type === BasketTypes.KYC) {
                sum += (basket.systemProvider.systemProviderSalesValues.filter(value => value.idPlanType === this.clientPlan.idPlanType)[0].saleValue) * this.clientPlan.kycPercentage
              } else {
                sum += (basket.systemProvider.systemProviderSalesValues.filter(value => value.idPlanType === this.clientPlan.idPlanType)[0].saleValue)
              }
            }
          })
        }
      }
      return sum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    async getClientPlan () {
      const allClients = await this.actionGetAllClients()
      const allPlans = await this.actionGetPlanTypes()
      const idClient = this.getterAccount.client.idClient

      const currentClient = allClients.data.filter(client => client.idClient === idClient)
      const currentPlan = allPlans.data.filter(plan => plan.idPlanType === currentClient[0].idPlanType)
      return currentPlan[0]
    },
    managerBasket (id = 'new') {
      this.$router.push({ name: 'DetailedBasket', params: { id } })
    },
    formatTypeBasket (value) {
      let result = 'Desconhecido'

      if (value) {
        switch (value) {
          case BasketTypes.BUSCA:
            result = 'Busca'
            break
          case BasketTypes.VALIDACAO:
            result = 'Validação'
            break
          case BasketTypes.HIERARQUICA:
            result = 'Hieráquica'
            break
          case BasketTypes.BUSCA_VALIDACAO:
            result = 'Busca / Validação'
            break
          case BasketTypes.KYC:
            result = 'Kyc'
            break
          default:
            result = 'Desconhecido'
        }
      }

      return result
    },
    getAllBaskets () {
      this.isLoadingAllbaskets = true

      this.actionGetAllBaskets(this.getterAccount.idClient)
        .then(() => {
          this.setFilters()

          this.isLoadingAllbaskets = false
        })
        .catch(() => {
          this.isLoadingAllbaskets = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar as cestas, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    setFilters () {
      if (Object.keys(this.$route.query).length > 0 && this.$route.query.idProviderFlow) {
        this.selectedFilter = 'idProviderFlow'
        this.search = this.$route.query.idProviderFlow

        this.sendToast({
          text: 'A cesta que você gerenciou foi selecionada',
          type: 'success'
        })
      }
    },
    managerBasketsModals (type, basket) {
      switch (type) {
        case 'edit':
          this.managerBasket(basket.idProviderFlow)
          break
        case 'remove':
          this.SET_SELECTED_BASKET(basket)

          this.managerDeleteBasket = true
          break
        default:
          this.managerBasket()
      }

      this.SET_SELECTED_BASKET(basket)
    }
  }
}
